import React from "react";
import PropTypes from "prop-types";
import { Typography, Box, Table, TableBody, TableContainer, TableHead, TableRow, TableCell } from "@mui/material";
import StagedAccessorialsTableRow from "../StagedAccessorialsTableRow/StagedAccessorialsTableRow";
import StyledTableCell from "../../StyledTable/StyledTableCell/StyledTableCell";
import StyledTableRow from "../../StyledTable/StyledTableRow/StyledTableRow";
import { formatCurrency } from "../../../../../../utils/formatHelpers";

const totalRowCellStyle = {
  borderTop: "2px solid",
  borderBottom: "0px",
  borderColor: "black_solid.30",
  paddingTop: "30px"
};

export default function StagedAccessorialsTable({
  stagedAccessorialsArray,
  setAccessorialToEdit,
  handleDeleteAccessorial,
  setStep,
  submitAll,
  handleUpdateAccessorial,
  totals,
  setDeleteModalOpen
}) {
  const columns = ["NO.", "ITEM", "STOP", "CARRIER COST", "TOTAL", "STATUS", "EDIT"];

  return (
    <Box>
      <TableContainer sx={{ borderRadius: "8px", marginTop: "10px" }}>
        <Table>
          <TableHead sx={{ backgroundColor: "black_solid.20" }}>
            <StyledTableRow>
              {columns.map((column) => (
                <StyledTableCell key={`header-cell-${column}`}>
                  <Typography variant="body1" color="black_solid.80">
                    {column}
                  </Typography>
                </StyledTableCell>
              ))}
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {stagedAccessorialsArray.map((accessorial) => (
              <StagedAccessorialsTableRow
                key={`accessorial-${accessorial.tempId || accessorial.id}`}
                accessorial={accessorial}
                setAccessorialToEdit={setAccessorialToEdit}
                handleDeleteAccessorial={handleDeleteAccessorial}
                setStep={setStep}
                submitAll={submitAll}
                handleUpdateAccessorial={handleUpdateAccessorial}
                setDeleteModalOpen={setDeleteModalOpen}
              />
            ))}
            <TableRow>
              <TableCell sx={totalRowCellStyle} />
              <TableCell sx={totalRowCellStyle}>
                <Typography variant="body1" color="black_solid.60">
                  Totals
                </Typography>
              </TableCell>
              <TableCell sx={totalRowCellStyle} />
              <TableCell sx={totalRowCellStyle}>
                <Typography variant="body1" color="black_solid.80">
                  {formatCurrency(totals.carrierCost, 2)}
                </Typography>
              </TableCell>
              <TableCell sx={totalRowCellStyle}>
                <Typography variant="body1" color="black_solid.80">
                  {formatCurrency(totals.carrierTotal, 2)}
                </Typography>
              </TableCell>
              <TableCell sx={totalRowCellStyle} />
              <TableCell sx={totalRowCellStyle} />
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

StagedAccessorialsTable.propTypes = {
  stagedAccessorialsArray: PropTypes.array.isRequired,
  setAccessorialToEdit: PropTypes.func.isRequired,
  handleDeleteAccessorial: PropTypes.func.isRequired,
  setStep: PropTypes.func.isRequired,
  submitAll: PropTypes.bool,
  handleUpdateAccessorial: PropTypes.func.isRequired,
  totals: PropTypes.object,
  setDeleteModalOpen: PropTypes.func.isRequired
};